import { FairPlayWithShadow } from '@assets/svg';
import { RawButton } from '@shared/RawButton';
import styles from './FairPlayMark.module.scss';

export const FairPlayMark = ({ onClick }: { onClick?: VoidFunction }) => {
  return (
    <RawButton className={styles.fairPlay} onClick={onClick}>
      <FairPlayWithShadow />
    </RawButton>
  );
};
